import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import LoadingScreen from '../LoadingScreen';

interface AdminGuardProps {
  children: React.ReactNode;
}

const AdminGuard: React.FC<AdminGuardProps> = ({ children }) => {
  const { isAuthenticated, loading, user } = useAuth();
  const location = useLocation();

  // Show loading screen while checking authentication
  if (loading) {
    return <LoadingScreen />;
  }

  // If not authenticated, redirect to homepage
  if (!isAuthenticated() || !user) {
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  // If authenticated but not admin, redirect to home
  // Check role (case-insensitive) and isAdmin property
  const userRole = typeof user.role === 'string' ? user.role.toLowerCase() : '';
  const isUserAdmin = user.isAdmin === true || userRole === 'admin';
  
  if (!isUserAdmin) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
};

export default AdminGuard;

